import { Modal } from '@/components/ui/Modal';
import SetPictureModal from '../../../../../components/modals/setPictureModal/SetPictureModal';
import RenameModal from '../../../../../components/modals/renameModal/renameModal';
import UpdateEmailModal from '../../../../../components/modals/updateEmailModal/UpdateEmailModal';

interface ProfileModalsProps {
  modalOpen: string | false;
  handleCloseModalClick: () => void;
  currentUserInfo: Record<string, unknown>;
  updateCurrentUserInfo: () => void;
  updateIsQuerying: (querying: boolean) => void;
  getWorkspacePeopleList: () => void;
}

const MODAL_TITLES: Record<string, string> = {
  uploadProfile: 'Profile picture',
  updateEmail: 'Update email',
  updateFirstname: 'Update first name',
  updateLastname: 'Update surname',
};

export default function ProfileModals({
  modalOpen,
  handleCloseModalClick,
  currentUserInfo,
  updateCurrentUserInfo,
  updateIsQuerying,
  getWorkspacePeopleList,
}: ProfileModalsProps) {
  return (
    <Modal
      open={!!modalOpen}
      onClose={handleCloseModalClick}
      title={modalOpen ? MODAL_TITLES[modalOpen] : ''}
      size="md"
    >
      {modalOpen === 'uploadProfile' && (
        <SetPictureModal
          currentUserInfo={currentUserInfo}
          closeModal={handleCloseModalClick}
          useCase="profile"
          updateCurrentUserInfo={updateCurrentUserInfo}
          updateIsQuerying={updateIsQuerying}
          hasImage={
            (currentUserInfo as { image?: { S: string } }).image !== undefined &&
            (currentUserInfo as { image?: { S: string } }).image?.S !== 'no-image'
          }
          getWorkspacePeopleList={getWorkspacePeopleList}
        />
      )}
      {modalOpen === 'updateEmail' && (
        <UpdateEmailModal
          closeModal={handleCloseModalClick}
          updateIsQuerying={updateIsQuerying}
          updateCurrentUserInfo={updateCurrentUserInfo}
        />
      )}
      {modalOpen === 'updateFirstname' && (
        <RenameModal
          closeModal={handleCloseModalClick}
          updateIsQuerying={updateIsQuerying}
          updateCurrentUserInfo={updateCurrentUserInfo}
          item={{ ...currentUserInfo, itemtype: { S: 'firstname' } }}
          title="Update first name"
          placeholder="New first name"
          getWorkspacePeopleList={getWorkspacePeopleList}
        />
      )}
      {modalOpen === 'updateLastname' && (
        <RenameModal
          closeModal={handleCloseModalClick}
          updateIsQuerying={updateIsQuerying}
          updateCurrentUserInfo={updateCurrentUserInfo}
          item={{ ...currentUserInfo, itemtype: { S: 'lastname' } }}
          title="Update surname"
          placeholder="New surname"
          getWorkspacePeopleList={getWorkspacePeopleList}
        />
      )}
    </Modal>
  );
}
